export const FETCH_GROUPS = 'Groups/FETCH_GROUPS';
export const FETCH_GROUPS_SUCCESS = 'Groups/FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'Groups/FETCH_GROUPS_FAILURE';

export const FETCH_REMOVE_GROUP = 'Groups/FETCH_REMOVE_GROUP';
export const FETCH_REMOVE_GROUP_SUCCESS = 'Groups/FETCH_REMOVE_GROUP_SUCCESS';
export const FETCH_REMOVE_GROUP_FAILURE = 'Groups/FETCH_REMOVE_GROUP_FAILURE';

export const FETCH_SAVE_GROUP = 'Groups/FETCH_SAVE_GROUP';
export const FETCH_SAVE_GROUP_SUCCESS = 'Groups/FETCH_SAVE_GROUP_SUCCESS';
export const FETCH_SAVE_GROUP_FAILURE = 'Groups/FETCH_SAVE_GROUP_FAILURE';

export const FETCH_USERS_FOR_GROUP = 'Groups/FETCH_USERS_FOR_GROUPS';
export const FETCH_USERS_FOR_GROUP_SUCCESS = 'Groups/FETCH_USERS_FOR_GROUPS_SUCCESS';
export const FETCH_USERS_FOR_GROUP_FAILURE = 'Groups/FETCH_USERS_FOR_GROUPS_FAILURE';

export const CLEAR_GROUP = 'Groups/CLEAR_GROUP';
export const EMPTY_GROUPS = 'Groups/EMPTY_GROUPS';
export const SET_GROUP = 'Groups/SET_GROUP';
export const UPDATE_FILTER_BY = 'Groups/UPDATE_FILTER_BY';
export const UPDATE_GROUPS = 'Groups/UPDATE_GROUPS';
export const UPDATE_SEARCH_TERM = 'Groups/UPDATE_SEARCH_TERM';
export const UPDATE_SORT_BY = 'Groups/UPDATE_SORT_BY';
export const UPDATE_THUMBNAIL_TO_UPLOAD = 'Groups/UPDATE_THUMBNAIL_TO_UPLOAD';



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/groups/constants.js